import * as yup from 'yup';
import { fields } from '../constants';

export const fileTooLargeError =
  'Your video exceeds the 500MB limit. Try compressing the file or uploading a shorter version.';

export enum MediaTypes {
  image = 'image',
  video = 'video',
};

export const schema = yup.object().shape({
  [fields.files.path]: fields.files.rule,
});

export const uploadFileSizeLimit = 500 * 1000 * 1000; // 500 MB
